import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { eduplayClient } from '@/data/@clients';
import type { UseIndexLessonsResponse } from '@/data/eduplay/courses/interfaces';

export const useSetCurrentCourseLesson = (courseId: number) => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: async (lessonId: string) =>
      await eduplayClient.put(`/cursos/${courseId}/aula_atual`, {
        aula_atual: lessonId,
      }),
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: ['lessons', courseId],
      });
    },
  });
};

export const useIndexCourseLessons = (courseId: number) =>
  useQuery<UseIndexLessonsResponse>({
    queryKey: ['lessons', courseId],
    queryFn: async () => await eduplayClient.get(`/cursos/${courseId}/aulas`),
  });
